import React from "react";
import "./report.css";

function Report() {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">

          <div className="reportMainContainer">

            {/* TITLE */}
            <div className="reportPageTitle">
              Báo cáo hệ thống
            </div>

            {/* BREADCRUMB */}
            <div className="reportBreadcrumbWrapper">
              <div className="reportBreadcrumbText">Trang chủ</div>
              <div className="reportBreadcrumbText">/</div>
              <div className="reportBreadcrumbText">Báo cáo hệ thống</div>
            </div>

            {/* FILTER */}
            <div className="reportFilterCard">

              <div className="report-filter">

                <h6 className="reportFilterTitle">
                  Bộ lọc báo cáo
                </h6>

                <button className="reportExportButton">
                  <i className="fa-solid fa-download"></i>
                  Xuất báo cáo
                </button>

              </div>

              <div className="reportFilterRow">

                <div className="reportFilterItem">
                  <label className="reportFilterLabel">
                    Loại báo cáo
                  </label>

                  <select className="reportFilterSelect">
                    <option>Tổng quan hệ thống</option>
                  </select>
                </div>

                <div className="reportFilterItem">
                  <label className="reportFilterLabel">
                    Khoảng thời gian
                  </label>

                  <select className="reportFilterSelect">
                    <option>7 ngày qua</option>
                  </select>
                </div>

                <div className="reportFilterItem">
                  <label className="reportFilterLabel">
                    Từ ngày
                  </label>

                  <input
                    type="date"
                    className="reportFilterDate"
                    defaultValue="2024-05-14"
                  />
                </div>

                <div className="reportFilterItem">
                  <label className="reportFilterLabel">
                    Đến ngày
                  </label>

                  <input
                    type="date"
                    className="reportFilterDate"
                    defaultValue="2024-05-20"
                  />
                </div>

                <button className="reportViewButton">
                  <i className="fa-solid fa-chart-column"></i>
                  Xem báo cáo
                </button>

              </div>

            </div>

            {/* SUMMARY */}
            <div className="reportSummaryRow">

              <div className="reportSummaryCard reportCardBlue">
                <div className="reportSummaryTop">

                  <div className="reportSummaryTitle">
                    Người dùng hệ thống
                  </div>

                  <i className="fa-solid fa-user-group reportSummaryIcon reportBlue"></i>

                </div>

                <div className="reportSummaryValue">
                  156
                </div>

                <div className="reportSummaryBottom blueText">
                  <i className="fa-solid fa-arrow-up"></i>
                  12 (8.33%) so với 7 ngày trước
                </div>
              </div>

              <div className="reportSummaryCard reportCardGreen">
                <div className="reportSummaryTop">

                  <div className="reportSummaryTitle">
                    Đăng nhập thành công
                  </div>

                  <i className="fa-regular fa-circle-check reportSummaryIcon reportGreen"></i>

                </div>

                <div className="reportSummaryValue">
                  1.248
                </div>

                <div className="reportSummaryBottom greenText">
                  <i className="fa-solid fa-arrow-up"></i>
                  120 (10.64%) so với 7 ngày trước
                </div>
              </div>

              <div className="reportSummaryCard reportCardOrange">
                <div className="reportSummaryTop">

                  <div className="reportSummaryTitle">
                    Đăng nhập thất bại
                  </div>

                  <i className="fa-solid fa-triangle-exclamation reportSummaryIcon reportOrange"></i>

                </div>

                <div className="reportSummaryValue">
                  32
                </div>

                <div className="reportSummaryBottom orangeText">
                  <i className="fa-solid fa-arrow-down"></i>
                  8 (20.00%) so với 7 ngày trước
                </div>
              </div>

              <div className="reportSummaryCard reportCardPurple">
                <div className="reportSummaryTop">

                  <div className="reportSummaryTitle">
                    Dữ liệu đã lưu trữ
                  </div>

                  <i className="fa-solid fa-database reportSummaryIcon reportPurple"></i>

                </div>

                <div className="reportSummaryValue">
                  256.7 GB
                </div>

                <div className="reportSummaryBottom purpleText">
                  <i className="fa-solid fa-arrow-up"></i>
                  28.5 GB (12.50%) so với 7 ngày trước
                </div>
              </div>

            </div>

            {/* CONTENT */}
            <div className="reportContentGrid">

              {/* LEFT CHART */}
              <div className="login-chart-wrapper">

                <div className="login-chart-header">

                  <h3 className="login-chart-title">
                    Thống kê đăng nhập
                  </h3>

                  <select className="login-chart-select">
                    <option>Theo ngày</option>
                  </select>

                </div>

                {/* NOTE */}
                <div className="login-chart-note">

                  <div className="login-chart-note-item">
                    <span className="login-success-color"></span>
                    <span>Thành công</span>
                  </div>

                  <div className="login-chart-note-item">
                    <span className="login-fail-color"></span>
                    <span>Thất bại</span>
                  </div>

                </div>

                {/* CHART */}
<div className="chartArea">

  {/* Y AXIS */}
  <div className="chartYAxis">
    <span>250</span>
    <span>200</span>
    <span>150</span>
    <span>100</span>
    <span>50</span>
    <span>0</span>
  </div>

  {/* GRID */}
  <div className="chartGrid"></div>

  {/* SVG */}
  <svg
    viewBox="0 0 700 300"
    preserveAspectRatio="none"
    className="chartSvg"
  >

    {/* GREEN LINE */}
    <polyline
      fill="none"
      stroke="#32C67A"
      strokeWidth="3"
      points="
      70,120
      120,122
      170,112
      220,95
      270,118
      320,90
      370,115
      420,88
      470,82
      520,72
      570,86
      620,80
      "
    />

    {/* GREEN POINTS */}
    <circle cx="70" cy="120" r="4" fill="#32C67A"/>
    <circle cx="120" cy="122" r="4" fill="#32C67A"/>
    <circle cx="170" cy="112" r="4" fill="#32C67A"/>
    <circle cx="220" cy="95" r="4" fill="#32C67A"/>
    <circle cx="270" cy="118" r="4" fill="#32C67A"/>
    <circle cx="320" cy="90" r="4" fill="#32C67A"/>
    <circle cx="370" cy="115" r="4" fill="#32C67A"/>
    <circle cx="420" cy="88" r="4" fill="#32C67A"/>
    <circle cx="470" cy="82" r="4" fill="#32C67A"/>
    <circle cx="520" cy="72" r="4" fill="#32C67A"/>
    <circle cx="570" cy="86" r="4" fill="#32C67A"/>
    <circle cx="620" cy="80" r="4" fill="#32C67A"/>

    {/* RED LINE */}
    <polyline
      fill="none"
      stroke="#FF5B5B"
      strokeWidth="3"
      points="
      70,250
      120,252
      170,253
      220,252
      270,238
      320,248
      370,250
      420,242
      470,252
      520,251
      570,238
      620,246
      "
    />

    {/* RED POINTS */}
    <circle cx="70" cy="250" r="4" fill="#FF5B5B"/>
    <circle cx="120" cy="252" r="4" fill="#FF5B5B"/>
    <circle cx="170" cy="253" r="4" fill="#FF5B5B"/>
    <circle cx="220" cy="252" r="4" fill="#FF5B5B"/>
    <circle cx="270" cy="238" r="4" fill="#FF5B5B"/>
    <circle cx="320" cy="248" r="4" fill="#FF5B5B"/>
    <circle cx="370" cy="250" r="4" fill="#FF5B5B"/>
    <circle cx="420" cy="242" r="4" fill="#FF5B5B"/>
    <circle cx="470" cy="252" r="4" fill="#FF5B5B"/>
    <circle cx="520" cy="251" r="4" fill="#FF5B5B"/>
    <circle cx="570" cy="238" r="4" fill="#FF5B5B"/>
    <circle cx="620" cy="246" r="4" fill="#FF5B5B"/>

  </svg>

  {/* DATE */}
  <div className="chartDates">

    <span>14/05</span>
    <span>15/05</span>
    <span>16/05</span>
    <span>17/05</span>
    <span>18/05</span>
    <span>19/05</span>
    <span>20/05</span>

  </div>

</div>

              </div>

              {/* RIGHT */}
              <div className="reportRightColumn">

                {/* PIE */}
                <div className="reportPieCard">

                  <div className="reportCardTitle">
                    Tỷ lệ sử dụng tài nguyên hệ thống
                  </div>

                  <div className="reportPieContent">

                    <div className="reportPieCircle">
                      <div className="reportPieInner"></div>
                    </div>

                    <div className="reportPieLegendWrapper">

                      <div className="reportPieLegendItem">
                        <div className="legendColor blue"></div>
                        CPU 32%
                      </div>

                      <div className="reportPieLegendItem">
                        <div className="legendColor green"></div>
                        RAM 45%
                      </div>

                      <div className="reportPieLegendItem">
                        <div className="legendColor yellow"></div>
                        Ổ đĩa 18%
                      </div>

                      <div className="reportPieLegendItem">
                        <div className="legendColor purple"></div>
                        Khác 5%
                      </div>

                    </div>

                  </div>

                </div>

                {/* SYSTEM */}
                <div className="reportSystemCard">

                  <div className="reportCardTitle">
                    Thông tin hệ thống
                  </div>

                  <div className="reportSystemRow">
                    <span>Tên hệ thống</span>
                    <strong>Hệ thống dữ liệu ngành Công Thương</strong>
                  </div>

                  <div className="reportSystemRow">
                    <span>Phiên bản</span>
                    <strong>v2.3.1</strong>
                  </div>

                  <div className="reportSystemRow">
                    <span>Môi trường</span>
                    <strong>Production</strong>
                  </div>

                  <div className="reportSystemRow">
                    <span>Máy chủ</span>
                    <strong>AG-SCT-APP-01</strong>
                  </div>

                  <div className="reportSystemRow">
                    <span>Cơ sở dữ liệu</span>
                    <strong>SQL Server 2019</strong>
                  </div>

                </div>

              </div>

            </div>

            {/* TABLE */}
            <div className="reportBottomGrid">

              {/* LEFT TABLE */}
              <div className="reportTableCard">

                <div className="reportTopActionTitle">
  Top thao tác nhiều nhất
</div>

                <table className="reportTable">

                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Chức năng</th>
                      <th>Số lượt truy cập</th>
                      <th>Tỷ lệ (%)</th>
                    </tr>
                  </thead>

                  <tbody>

<tr>
  <td>1</td>
  <td>Đăng nhập hệ thống</td>
  <td>1.248</td>

  <td>
    <div className="reportPercentCell">
      <div className="reportPercentBar">
        <div
          className="reportPercentFill"
          style={{ width: "100%" }}
        ></div>
      </div>

      <span>24.15%</span>
    </div>
  </td>
</tr>

<tr>
  <td>2</td>
  <td>Tra cứu dữ liệu</td>
  <td>1.086</td>

  <td>
    <div className="reportPercentCell">
      <div className="reportPercentBar">
        <div
          className="reportPercentFill"
          style={{ width: "87%" }}
        ></div>
      </div>

      <span>20.98%</span>
    </div>
  </td>
</tr>

<tr>
  <td>3</td>
  <td>Xuất báo cáo</td>
  <td>892</td>

  <td>
    <div className="reportPercentCell">
      <div className="reportPercentBar">
        <div
          className="reportPercentFill"
          style={{ width: "72%" }}
        ></div>
      </div>

      <span>17.26%</span>
    </div>
  </td>
</tr>

<tr>
  <td>4</td>
  <td>Cập nhật dữ liệu</td>
  <td>764</td>

  <td>
    <div className="reportPercentCell">
      <div className="reportPercentBar">
        <div
          className="reportPercentFill"
          style={{ width: "61%" }}
        ></div>
      </div>

      <span>14.78%</span>
    </div>
  </td>
</tr>

<tr>
  <td>5</td>
  <td>Quản lý danh mục</td>
  <td>588</td>

  <td>
    <div className="reportPercentCell">
      <div className="reportPercentBar">
        <div
          className="reportPercentFill"
          style={{ width: "47%" }}
        ></div>
      </div>

      <span>11.37%</span>
    </div>
  </td>
</tr>

<tr>
  <td>6</td>
  <td>Phân quyền</td>
  <td>256</td>

  <td>
    <div className="reportPercentCell">
      <div className="reportPercentBar">
        <div
          className="reportPercentFill"
          style={{ width: "20%" }}
        ></div>
      </div>

      <span>4.95%</span>
    </div>
  </td>
</tr>

<tr>
  <td>7</td>
  <td>Khác</td>
  <td>328</td>

  <td>
    <div className="reportPercentCell">
      <div className="reportPercentBar">
        <div
          className="reportPercentFill"
          style={{ width: "26%" }}
        ></div>
      </div>

      <span>6.34%</span>
    </div>
  </td>
</tr>

</tbody>

                </table>

              </div>

              {/* RIGHT TABLE */}
              <div className="reportTableCard">

                <div className="reportLogTitle">
  Nhật ký hệ thống mới nhất
</div>

                <table className="reportTable">

<thead>
  <tr>
    <th>Thời gian</th>
    <th>Người dùng</th>
    <th>Hành động</th>
    <th>Địa chỉ IP</th>
  </tr>
</thead>

<tbody>

<tr>
  <td>20/05/2024 14:32:15</td>
  <td>admin</td>
  <td className="logSuccess">Đăng nhập thành công</td>
  <td className="ipSuccess">10.10.10.15</td>
</tr>

<tr>
  <td>20/05/2024 14:28:45</td>
  <td>nguyen.van.a</td>
  <td>Xuất báo cáo</td>
  <td>10.10.10.23</td>
</tr>

<tr>
  <td>20/05/2024 14:25:10</td>
  <td>tran.thi.b</td>
  <td>Cập nhật dữ liệu</td>
  <td>10.10.10.45</td>
</tr>

<tr>
  <td>20/05/2024 14:22:05</td>
  <td>le.van.c</td>
  <td className="logDanger">Đăng nhập thất bại</td>
  <td className="ipDanger">10.10.10.67</td>
</tr>

<tr>
  <td>20/05/2024 14:18:30</td>
  <td>pham.thi.d</td>
  <td>Phân quyền người dùng</td>
  <td>10.10.10.89</td>
</tr>

</tbody>

                </table>

              </div>

            </div>

          </div>

        </div>
      </div>
    </div>
  );
}

export default Report;